import { useEffect } from 'react';

interface UseScrollListenerProps {
  enabled: boolean;
  onScroll: () => void;
  useCapture?: boolean;
}

/**
 * Custom hook that executes an action when the user scrolls
 * @param enabled - State that indicates whether the listener should be active
 * @param onScroll - Callback function that executes when scrolling occurs
 * @param useCapture - Whether to use event capture (default true)
 */
export const useScrollListener = ({
  enabled,
  onScroll,
  useCapture = true,
}: UseScrollListenerProps) => {
  useEffect(() => {
    const handleScroll = () => {
      if (enabled) {
        onScroll();
      }
    };

    if (enabled) {
      window.addEventListener('scroll', handleScroll, useCapture);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll, useCapture);
    };
  }, [enabled, onScroll, useCapture]);
};
